module.exports = __webpack_public_path__ + "static/media/15UN-Habitat14.800a98f9.jpg";